import React, { useEffect } from "react";
import { loadTermlyScript } from "./termly_script";

const EMBED_DATA_ID = "c42d567d-83b8-4f54-ab03-6806cbce18c0";

export function TermsConditionsRender(): React.ReactElement {
  useEffect(() => {
    loadTermlyScript();
  }, []);

  const divProps: React.HTMLAttributes<HTMLDivElement> & { name: string; "data-id": string } = {
    name: "termly-embed",
    "data-id": EMBED_DATA_ID,
  };
  return <div {...divProps} />;
}
